import { Inject, Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import {
  Analytics,
  CustomParams,
  logEvent,
  setAnalyticsCollectionEnabled,
  setUserId,
  setUserProperties,
} from 'firebase/analytics';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private platform: Platform, @Inject('FIREBASE_ANALYTICS') private analytics: Analytics) {}

  logEvent(name: string, data?: {}) {
    if (this.useWebPackage()) {
      FirebaseAnalytics.logEvent({
        name,
        params: data,
      });
    } else {
      logEvent(this.analytics, name, data);
    }
  }

  setEnabled(enabled: boolean) {
    if (this.useWebPackage()) {
      FirebaseAnalytics.setEnabled({
        enabled,
      });
    } else {
      setAnalyticsCollectionEnabled(this.analytics, enabled);
    }
  }

  setPage(pageName: string) {
    if (this.useWebPackage()) {
      FirebaseAnalytics.setCurrentScreen({
        screenName: pageName,
      });
    } else {
      logEvent(this.analytics, 'screen_view' as string, {
        screen_name: pageName,
      });
    }
  }

  async initUser(uid: string, email: string, displayName: string) {
    let userProps: CustomParams = {
      email,
      displayName: displayName,
      platform: Capacitor.getPlatform(),
    };
    console.log('user platform:', userProps['platform']);

    // if (user.metadata) {
    //   userProps['created'] = user.metadata.creationTime;
    //   userProps['last_login'] = user.metadata.lastSignInTime;
    // }

    if (this.useWebPackage()) {
      FirebaseAnalytics.setUserId({ userId: uid });
      Object.keys(userProps).forEach(key => {
        FirebaseAnalytics.setUserProperty({
          key: key,
          value: (userProps[key] as string) || null,
        });
      });
    } else {
      setUserId(this.analytics, email);
      setUserProperties(this.analytics, userProps);
    }
  }

  reset() {
    if (this.useWebPackage()) {
      FirebaseAnalytics.resetAnalyticsData();
    } else {
    }
  }

  logError(message: string, error: any) {
    console.error(message, error);
    const fullError = {
      message,
      error,
      path: window.location.pathname,
    };
    if (this.useWebPackage()) {
      FirebaseAnalytics.logEvent({
        name: 'error',
        params: fullError,
      });
    } else {
      logEvent(this.analytics, 'error', fullError);
    }
  }

  private useWebPackage(): boolean {
    return Capacitor.getPlatform() === 'ios';
  }
}
